import { Module } from 'vuex'
import axios from '@/plugins/axios'

const schedulesModule: Module<any, any> = {
    state: {
        networkObj: {},
    },
    actions: {
        async getSchedules(_, params) {
            const page = params?.page ?? 1

            let url = '/api/schedules?page=' + page                        
            url += params.perPage ? '&itemPerPage=' + params.perPage : ''

            url += params.workspaceMember
                ? '&workspaceMember=' + params.workspaceMember
                : ''
            if (params.workspaceMemberIds?.length) {
                url +=
                    '&workspaceMemberIds=' +
                    (Array.isArray(params.workspaceMemberIds)
                        ? params.workspaceMemberIds.join(',')
                        : String(params.workspaceMemberIds))
            }
            url += params.type ? '&type=' + params.type : ''
            url += params.status ? '&status=' + params.status : ''
            url += params.networkConnection
                ? '&networkConnectionIds=' + params.networkConnection
                : ''
            url += params.networkConnectionIds
                ? '&networkConnectionIds=' + params.networkConnectionIds.join(',')
                : ''
            url += params.content ? '&content=' + params.content : ''
            url += params.contentIds ? '&contentIds=' + params.contentIds : ''
            url += params.campaign ? '&campaign=' + params.campaign : ''
            url += params.postId
                ? '&postId=' + params.postId
                : ''
            url += params.memberType ? '&memberType=' + params.memberType : ''
            url += params.socialNetwork
                ? '&socialNetwork=' + params.socialNetwork
                : ''
            url += params.from ? `&publishDate[from]=${params.from}` : ''
            url += params.to ? `&publishDate[to]=${params.to}` : ''

            url += params?.sortKey ? `&sort=${params.sortKey}` : ''
            url += params?.sortOrder ? `&order=${params.sortOrder}` : ''

			if (params.onePerAction) {
				url += '&onePerAction=1'
			}

            // Temporary to work around caching issue

            url += '&ts=' + Date.now()

            const { data } = await axios.get(url)
            return data
        },

        async exportSchedules(_, params) {
            let filters = ''          
            filters += params.perPage || params?.perPage===0 ? '?itemPerPage=' + params.perPage : '?'

            filters += params.workspaceMember
                ? '&workspaceMember=' + params.workspaceMember
                : ''
            filters += params.type ? '&type=' + params.type : ''
            filters += params.status ? '&status=' + params.status : ''
            filters += params.networkConnection
                ? '&networkConnectionIds=' + params.networkConnection
                : ''
            filters += params.content ? '&content=' + params.content : ''
            filters += params.contentIds ? '&contentIds=' + params.contentIds : ''
            filters += params.memberType ? '&memberType=' + params.memberType : ''
            filters += params.socialNetwork
                ? '&socialNetwork=' + params.socialNetwork
                : ''
            filters += params.from ? `&publishDate[from]=${params.from}` : ''
            filters += params.to ? `&publishDate[to]=${params.to}` : ''

			if (params.onePerAction) {
				filters += '&onePerAction=1'
			}

            filters += '&ts=' + Date.now()

            const { data } = await axios.get(
                `/api/schedules/export${filters}`,
            )
            return data
        },

        // Distinct team members who published in a date range/network -
        // powers the "Active Members" card on /reporting/followers. Only
        // ever called with itemPerPage=1; the frontend reads
        // hydra:totalItems, not the row list.
        async getDistinctPublishingMembersCount(_, params) {
            let filters = params.perPage ? '?itemPerPage=' + params.perPage : '?itemPerPage=1'

            filters += params.socialNetwork ? '&socialNetwork=' + params.socialNetwork : ''
            filters += params.from ? `&publishDate[from]=${params.from}` : ''
            filters += params.to ? `&publishDate[to]=${params.to}` : ''

            const { data } = await axios.get(
                `/api/schedules/publishing-members-count${filters}`,
            )
            return data
        },

        async getSchedule(_, id) {
            const { data } = await axios.get(`/api/schedules/${id}`)
            return data
        },

        async createSchedule(_, params) {
            const { data } = await axios.post('/api/schedules', params)
            return data
        },

        async immediateSchedule(_, params) {
            const { data } = await axios.post('/api/schedules/immediate', params)
            return data
        },

        async updateSchedule(_, params) {
            const { data } = await axios.put(`/api/schedules/${params.id}/publish_at`, {
                publishAt: params.publishAt,
            })
            return data
        },

        async deleteSchedule(_, id) {
            const { data } = await axios.delete(`/api/schedules/${id}`)
            return data
        },

        async deleteScheduleEmergency(_, id) {
            const { data } = await axios.delete(`/api/schedules/${id}`)
            return data
        },

        async approveSchedule(_, id) {
            const { data } = await axios.put(
                '/api/schedules/' + id + '/approve',
                { approve: true },
            )

            return data
        },

        async rejectSchedule(_, id) {
            const { data } = await axios.put(`/api/schedules/${id}/approve`, {
                approve: false,
            })

            return data
        },

        async retrySchedule(_, params) {
            const id = typeof params === 'object' ? params.id : params
            const body =
                typeof params === 'object' && params.publishAt
                    ? { publishAt: params.publishAt }
                    : {}

            const { data } = await axios.put(`/api/schedules/${id}/retry`, body)

            return data
        },

        async scheduleCustomTitle(_, params) {
            const { data } = await axios.put(`/api/schedules/${params.id}/custom_title`, {title: params.title, description: params.description ?? null})
            return data
        },
        
        async scheduleCustomMessage(_, params) {
            const { data } = await axios.put(`/api/schedules/${params.id}/custom_message`, {message: params.message})
            return data
        },

    },
    getters: {
        getSelectedNetworkId: (state) => state.networkId,
    },
    mutations: {
        setSelectedNetworkId(state: any, networkObj: any) {
            state.networkObj = networkObj
        },
    },
}

export default schedulesModule
